import { Component, EventEmitter, Output, OnInit, Inject } from '@angular/core';
import { Validators, FormControl } from '@angular/forms';
import { HealthService } from '@app/services/health/health.service';
import { Tag } from '@app/_models/health';
import { Observable } from 'rxjs';
import { startWith, map, filter } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material';
@Component({
  selector: 'health-add-tag',
  templateUrl: './health-add-tag.component.html',
  styleUrls: ['./health-add-tag.component.scss'],
})
export class HealthAddTagComponent implements OnInit {
  constructor(
    private _healthService: HealthService,
    private _snackBar: MatSnackBar
  ) { }
  @Output() onAddedTag = new EventEmitter<Tag>();
  tagName = new FormControl('', Validators.required);
  tags: Tag[];
  filteredTags: Observable<Tag[]>;

  ngOnInit(): void {
    this._healthService.getTags().subscribe((tags: Tag[]) => {
      this.tags = tags;
      this.filteredTags = this.tagName.valueChanges.pipe(
        startWith(''),
        map(val => this.filter(val))
      );
    });
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
  }
  addTag(): void {
    if (this.tagName.valid) {
      const writtenTag = this.tagName.value;
      const selectedTag = this.tags.find((tag) => {
        return tag.name === writtenTag;
      });
      if (!selectedTag) {
        this._healthService.createTag(writtenTag).subscribe(newTag => {
          this.onAddedTag.emit(newTag);
        });
      } else {
        this.onAddedTag.emit(selectedTag);
      }
    } else {
      this.tagName.markAllAsTouched();
    }
  }

  removeTag(tag: Tag, idx: number) {
    this.tags = this.tags.filter((e) => e.id !== tag.id);
    this.tagName.setValue('');
    this._healthService.deleteTag(tag.id).subscribe(() => {
      this._snackBar.open('Tag eliminado correctamente', '', {
        duration: 3000,
      });
    });
  }

  getTagText(tag: Tag) {
    return tag.name;
  }

  filter(val: string) {

    return this.tags.filter((s) => new RegExp(val, 'gi').test(s.name));
  }
}
